import { useState, type FormEvent, type ReactNode } from 'react';
import { ApiError } from './api.js';

export function LoginScreen({ onSignIn }: { onSignIn: (password: string) => Promise<void> }): ReactNode {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await onSignIn(password);
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : 'Не удалось связаться со Studio.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <form className="login-card" onSubmit={(event) => void submit(event)}>
        <p className="eyebrow">Creative Studio</p>
        <h1>Откройте Workspace.</h1>
        <label htmlFor="studio-password">Пароль Workspace</label>
        <input
          id="studio-password"
          name="password"
          type="password"
          autoComplete="current-password"
          autoFocus
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        {error !== null ? (
          <p className="login-error" role="alert">
            {error}
          </p>
        ) : null}
        <button className="primary" type="submit" disabled={busy || password === ''}>
          {busy ? 'Открываю…' : 'Открыть Workspace'}
        </button>
      </form>
    </main>
  );
}
